import "./pages.css";

export default function Faqs() {

  return (

    <div className="page-container">

      <h1>Frequently Asked Questions</h1>

      <div className="faq-box">

        <h3>What is THCA?</h3>

        <p>
          THCA is a non-psychoactive cannabinoid found in hemp plants.
        </p>

      </div>

      <div className="faq-box">

        <h3>How long does shipping take?</h3>

        <p>
          Orders usually arrive within 3-7 business days.
        </p>

      </div>

      <div className="faq-box">

        <h3>Do you offer refunds?</h3>

        <p>
          Yes. Contact support within 7 days after delivery.
        </p>

      </div>

      <div className="faq-box">

        <h3>Are your products lab tested?</h3>

        <p>
          Yes, all products are third-party lab tested.
        </p>

      </div>

    </div>
  );
}